<template>
  <ul class="list-group">
    <li
      class="list-group-item"
      v-for="a in store.accounts"
      :key="a.id"
      :class="secondaryIfInactive(a.active)"
    >
      <span
        @click="selectAccount(a.id, a.name)"
        v-if="selectedAccount != a.id"
        >{{ a.name }}</span
      >
      <span v-if="selectedAccount == a.id">
        <div class="row d-flex align-items-center">
          <div class="col-6">
            <input type="text" class="form-control" v-model="newName" />
          </div>
          <div class="col">
            <span
              class="badge rounded-pill bg-success"
              v-if="a.active"
              @click="toggleActive(a.id, a.active)"
              >Active</span
            >
            <span
              class="badge rounded-pill bg-danger"
              v-if="!a.active"
              @click="toggleActive(a.id, a.active)"
              >Closed</span
            >
          </div>
          <div class="col">
            <button
              class="btn btn-sm btn-success float-end"
              @click="updateAccount()"
            >
              OK
            </button>
          </div>
        </div>
      </span>
    </li>
  </ul>
</template>
<script setup>
import { useStore } from "../../store/index";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config.js";
import { ref } from "vue";
const store = useStore();
const selectedAccount = ref("");
const newName = ref("");
const selectAccount = (id, name) => {
  if (selectedAccount.value != id) {
    selectedAccount.value = id;
    newName.value = name;
  } else {
    selectedAccount.value = "";
    newName.value = "";
  }
};
const updateAccount = async () => {
  const accountRef = doc(db, "accounts", selectedAccount.value);
  await updateDoc(accountRef, {
    name: newName.value,
  });
  selectedAccount.value = "";
};
const toggleActive = async (id, active) => {
  const accountRef = doc(db, "accounts", selectedAccount.value);
  await updateDoc(accountRef, {
    active: !active,
  });
  selectedAccount.value = "";
};
const secondaryIfInactive = (active) => {
  var cl = "";
  if (!active) {
    cl = "bg-secondary";
  }
  return cl;
};
</script>
